import { t } from "../../../services/utils";
import React from "react";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Inputbase from "@material-ui/core/InputBase";
import Button from "@material-ui/core/Button";
import Modal from "react-modal";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import DeleteIcon from "@material-ui/icons/Delete";
import PhotoIcon from "@material-ui/icons/Photo";
import Checkbox from "@material-ui/core/Checkbox";
import { toastr } from "react-redux-toastr";
import IconButton from "@material-ui/core/IconButton";
import Autocomplete from "@material-ui/lab/Autocomplete";
import uploadcare from "uploadcare-widget";
import { primaryDark5, primaryDark80 } from "../../../constants/colors";
import { STORY_VIEW_WIDTH } from "../../../constants/values";
import LoadingOverlay from "../../../components/LoadingOverlay";
import FileChip from "../../../components/FileChip";
import styles from "../components/PostnewsStyles";
import { getModalStyle } from "../../../services/modal-util";
import { today, toISOfromDate } from "../../../services/date-utils";
import uuidv4 from "uuid/v4";
import ReactTooltip from "react-tooltip";
import ProfileImageView from "../../../components/ProfileImageView";
import IconMoon from "../../../components/IconMoon";
import Tooltip from "../../../components/Tooltip";
import groupTypes from "../../../constants/group-types";
class PostNewsView extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.initState();
  }
  initState = () => {
    return {
      newPost: "",
      newPostDuplicate: "",
      open: false,
      selectValue: "",
      appNotification: false,
      pushNotification: false,
      isPublic: true,
      isPinned: false,
      pushNotificationMessage: "",
      for_everyone: true,
      segment_ids: [0],
      uploadedFiles: [],
      cover: null,
      uploadedFile: undefined,
      isUploading: false,
      arrowRef: null,
    };
  };
  componentDidMount() {
    const { groupId } = this.props;
    if (groupId) {
      this.setState({
        groupId,
        segment_ids: [groupId],
        for_everyone: false,
      });
    }
    if (groupId === 0) {
      this.setState({
        groupId,
        segment_ids: [groupId],
        for_everyone: true,
      });
    }
  }
  handleChange = (name) => (event) => {
    this.setState({
      [name]: event.target.value,
    });
  };
  handleSelectChange = (event, index, value) =>
    this.setState({
      selectValue: value,
    });
  openModal = () => {
    this.setState({
      open: true,
      newPost: this.state.newPostDuplicate,
    });
  };
  closeModal = () => {
    if (!this.state.isUploading) {
      this.setState({
        open: false,
        newPostDuplicate: this.state.newPost,
      });
    }
  };
  getGroupsList = () => {
    // const { groups } = this.props;
    let groups = Object.values(this.props.groups);
    groups = groups.filter(
      (group) => group.segment_type === groupTypes.FOR_GROUP
    );
    if (groups && groups.length > 0) {
      let options = groups.map((group) => ({
        label: group.name,
        value: group.id,
      }));
      return [
        {
          label: t("everyone"),
          value: 0,
        },
      ].concat(options);
    } else {
      return [];
    }
  };
  handleAppNotificationChange = (event, isInputChecked) => {
    this.setState({
      appNotification: isInputChecked,
      pushNotification: !isInputChecked ? false : this.state.pushNotification,
    });
  };
  onToggleChange = (toggleField) => {
    this.setState({
      [toggleField]: !this.state[toggleField],
    });
  };
  handleGroupsSelectionChange = (e, segment_ids, reason) => {
    const groups = segment_ids.map((group) => group.value);
    if (groups.indexOf(0) !== -1) {
      this.setState((prevState) => ({
        for_everyone: prevState.for_everyone ? false : true,
        segment_ids: prevState.for_everyone
          ? groups.filter((val) => val !== 0)
          : [0],
      }));
    } else {
      this.setState({
        for_everyone: false,
        segment_ids: groups,
      });
    }
  };
  handleRequestDelete = (index) => {
    const tempArray = this.state.uploadedFiles;
    tempArray.splice(index, 1);
    this.setState({
      uploadedFiles: tempArray,
    });
  };
  handleCoverDelete = () => {
    this.setState({
      cover: null,
    });
  };
  fileUpload = (type) => {
    let dialog = uploadcare.openDialog(null, {
      publicKey: process.env.UPLOADCARE_PUBLIC_KEY,
    });
    dialog.done((result) => {
      result.progress((info) => {
        this.setState({
          isUploading: true,
        });
        this.props.showLoading();
      });
      result.fail((info) => {
        this.setState({
          isUploading: false,
        });
        this.props.resetLoading();
        toastr.error(
          t("serverError"),
          t(
            "pleaseTryAfterSometimeIfProblemPersistsContactUsAtSupportTrainerfuCom"
          )
        );
      });
      result.done((info) => {
        if (type === "attachment") {
          const tempArray = this.state.uploadedFiles;
          tempArray.push({
            file_name: info.name,
            file_url: info.cdnUrl,
            info,
          });
          this.props.resetLoading();
          this.setState({
            uploadedFiles: tempArray,
            isUploading: false,
          });
        }
        if (type === "cover") {
          this.props.resetLoading();
          this.setState({
            cover: info,
            isUploading: false,
          });
        }
      });
    });
  };
  clearImage = () => {
    this.setState({
      uploadedFile: undefined,
    });
  };
  handleArrowRef = (node) => {
    this.setState({
      arrowRef: node,
    });
  };
  handlePost = () => {
    let payload = {};
    const {
      newPost,
      isPublic,
      isPinned,
      appNotification,
      pushNotification,
      pushNotificationMessage,
      segment_ids,
      uploadedFiles,
      cover,
    } = this.state;
    const files = [];
    this.state.uploadedFiles.map((file) => {
      files.push({
        name: file.file_name,
        url: file.file_url,
      });
    });
    payload = {
      newPost: newPost.trim(),
      isPublic,
      isPinned,
      appNotification,
      pushNotification,
      pushNotificationMessage,
      segment_ids,
      files,
      me: this.props.me,
      story_type: 4,
      date: toISOfromDate(today()),
      story_id: uuidv4(),
    };
    if (cover) {
      payload = {
        ...payload,
        image_url: cover.cdnUrl,
        image_width: cover.originalImageInfo.width,
        image_height: cover.originalImageInfo.height,
      };
    }
    this.props.postNews(payload);

    // this.props.postNews(
    //   newPost.trim(),
    //   isPublic,
    //   isPinned,
    //   appNotification,
    //   pushNotification,
    //   pushNotificationMessage,
    //   segment_ids,
    //   files
    // );
    this.setState(this.initState());
  };
  render = () => {
    let modalStyle1 = getModalStyle(STORY_VIEW_WIDTH, 600);
    modalStyle1.content = {
      ...modalStyle1.content,
      top: 98,
      marginTop: 0,
      maxHeight: 700,
      borderRadius: 4,
    };
    modalStyle1.overlay = {
      ...modalStyle1.overlay,
      zIndex: 1000,
    };
    const { uploadedFiles, cover } = this.state;
    let defaultValue = this.getGroupsList().filter((g) => {
      return this.state.for_everyone
        ? g.value === 0
        : g.value === this.state.segment_ids[0];
    });
    return (
      <Paper
        elevation={0}
        style={{
          margin: "0 2.5px",
        }}
      >
        <div style={styles.newPost}>
          <div
            style={{
              ...styles.row,
              ...{
                justifyContent: "space-between",
              },
            }}
            onClick={this.openModal}
          >
            <div
              style={{
                ...styles.textFieldRow,
                ...{
                  width: "80%",
                },
              }}
            >
              <ProfileImageView
                photoId={this.props.me?.photo_id}
                style={{
                  marginRight: 10,
                }}
                circular={true}
                placeholderSize={40}
                size={40}
              />
              <Inputbase
                placeholder={t("whatsOnYourMind")}
                multiline={true}
                rows={1}
                maxRows={5}
                fullWidth={true}
                onChange={this.handleChange("newPostDuplicate")}
                style={styles.textField}
                value={this.state.newPostDuplicate}
                inputProps={{ "data-testid": "post-news-trigger" }}
              />
            </div>
          </div>
        </div>
        <Modal
          isOpen={this.state.open}
          onRequestClose={this.closeModal}
          style={modalStyle1}
          contentLabel="Modal"
          ariaHideApp={false}
        >
          <div
            style={{
              ...styles.newPost,
              ...{
                marginTop: 0,
              },
            }}
          >
            {this.state.isUploading && <LoadingOverlay />}
            <div style={styles.row}>
              <div style={styles.textFieldRow}>
                <ProfileImageView
                  photoId={this.props.me?.photo_id}
                  style={{
                    marginRight: 10,
                    alignSelf: "flex-start",
                  }}
                  circular={true}
                  placeholderSize={40}
                  size={40}
                />
                <Inputbase
                  placeholder={t("whatsOnYourMind")}
                  multiline={true}
                  rows={1}
                  maxRows={10}
                  minRows={5}
                  fullWidth={true}
                  onChange={this.handleChange("newPost")}
                  // onClick={this.openModal}
                  style={styles.textField}
                  value={this.state.newPost}
                  autoFocus={true}
                  inputProps={{ "data-testid": "post-news-input" }}
                />
                <IconButton
                  onClick={this.closeModal}
                  style={{
                    alignSelf: "flex-start",
                  }}
                >
                  <IconMoon icon="close" />
                </IconButton>
              </div>
            </div>

            {cover && (
              <div>
                <DeleteIcon
                  style={{
                    ...styles.icon,
                    ...styles.deleteIcon,
                  }}
                  onClick={this.handleCoverDelete}
                />
                {<img src={cover.cdnUrl} style={styles.coverImage} />}
              </div>
            )}
            {uploadedFiles.length > 0 && (
              <div style={styles.attachmentsContainer}>
                {uploadedFiles.map((fileInfo, index) => (
                  <FileChip
                    key={fileInfo.file_url}
                    name={fileInfo.file_name}
                    url={fileInfo.file_url}
                    info={fileInfo.info}
                    style={styles.fileChip}
                    handleRequestDelete={(e) => {
                      e.stopPropagation();
                      this.handleRequestDelete(index);
                    }}
                    deleteable
                  />
                ))}
              </div>
            )}
            {/* <Divider style={styles.divider} /> */}
            <div style={styles.postOptions}>
              {/* <div style={styles.groupsContainerRow}>
                <div style={styles.label}>Who can see this?</div>
                <div style={{ width: "100%" }}>
                  <Select
                    style={{ width: "100%" }}
                    value={
                      this.state.for_everyone ? [0] : this.state.segment_ids
                    }
                    options={this.getGroupsList()}
                    onChange={this.handleGroupsSelectionChange}
                    clearable={true}
                    closeOnSelect={true}
                    disabled={false}
                    multi={true}
                    optionComponent={(val) => {
                      const { children, className, onSelect, option } = val;
                      return (
                        <div
                          onClick={() => onSelect(option)}
                          className={className}
                        >
                          {children}
                        </div>
                      );
                    }}
                  />
                </div>
               </div> */}

              <div style={styles.postButtons}>
                <div style={styles.icons}>
                  <Tooltip placement="top" title={t("addCoverPhoto")}>
                    <IconButton
                      style={styles.icon}
                      onClick={() => this.fileUpload("cover")}
                    >
                      <PhotoIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip placement="top" title={t("attachFile")}>
                    <IconButton
                      style={styles.icon}
                      onClick={() => this.fileUpload("attachment")}
                    >
                      <AttachFileIcon />
                    </IconButton>
                  </Tooltip>
                  <div style={styles.icon}>
                    <Checkbox
                      color="primary"
                      onChange={() => this.onToggleChange("isPinned")}
                      checked={this.state.isPinned}
                      style={styles.checkbox}
                    />
                    <span>{t("pinIt")}</span>
                  </div>
                  <div style={styles.icon}>
                    <Checkbox
                      color="primary"
                      onChange={this.handleAppNotificationChange}
                      checked={this.state.appNotification}
                      style={styles.checkbox}
                    />
                    <span>{t("sendNotification")}</span>
                  </div>
                </div>
              </div>
              {this.state.appNotification && (
                <TextField
                  size="small"
                  variant="outlined"
                  label={t("notificationText")}
                  value={this.state.pushNotificationMessage}
                  onChange={(event) => {
                    this.setState({
                      pushNotificationMessage: event.target.value,
                    });
                  }}
                  style={{
                    marginTop: 10,
                    backgroundColor: "white",
                  }}
                  fullWidth
                  InputProps={{
                    style: {
                      borderRadius: 6,
                    },
                  }}
                  inputProps={{
                    className: "modal-input",
                    style: {
                      paddingLeft: 20,
                      fontSize: 14,
                      lineHeight: "20px",
                    },
                  }}
                  InputLabelProps={{
                    style: styles.label,
                  }}
                  autoFocus
                />
              )}
              <div style={styles.buttons}>
                <Autocomplete
                  size="small"
                  multiple
                  id="tags-outlined"
                  options={this.getGroupsList()}
                  getOptionLabel={(option) => option.label}
                  defaultValue={defaultValue}
                  filterSelectedOptions
                  onChange={this.handleGroupsSelectionChange}
                  getOptionSelected={(option, value) =>
                    option.value === value.value
                  }
                  style={{
                    flex: 1,
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label={t("whichGroupsCanSeeThis")}
                    />
                  )}
                  ChipProps={{
                    style: {
                      color: primaryDark80,
                      backgroundColor: primaryDark5,
                      borderRadius: 6,
                      maxWidth: 125,
                    },
                  }}
                />
              </div>
              <div style={styles.submitBtn}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.handlePost}
                  style={styles.button}
                  data-testid="post-news-submit"
                >
                  {t("submit")}
                </Button>
              </div>
            </div>
          </div>
        </Modal>
        <ReactTooltip place="top" type="dark" effect="solid" id="postNews" />
      </Paper>
    );
  };
}
export default PostNewsView;
